import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: string) => {
  return {
    staticMenu:
      userType === "ADMIN"
        ? [
          {
            id: 101,
            label: "Dashboard",
            icon: WSIcons.Print,
            path: "/"
          },
          {
            id: 102,
            label: "Inventory",
            icon: WSIcons.OverViewIcon,
            children: [
              { id: 110, label: "Item Master", path: "/itemmaster/list" },
              { id: 111, label: "Category Management", path: "/category/list" },
              { id: 133, label: "Brand", path: "/brand/list" },
              { id: 112, label: "Unit Management", path: "/unit/list" },
              { id: 113, label: "Supplier Management", path: "/supplier/list" },
              { id: 114, label: "Customer Management", path: "/customer/list" },
              { id: 115, label: "Warehouse Management", path: "/warehouse/list" },
              { id: 116, label: "Opening Stock Entry", path: "/openingstock/list" },
              { id: 117, label: "Stock Entry", path: "/stockentry/list" },
              { id: 118, label: "Stock Adjustment", path: "/adjustment/list" },
              { id: 119, label: "Stock Balance", path: "/stock-balance/list" },
              { id: 120, label: "Stock Verification", path: "/verification/list" },
              { id: 121, label: "Stock Ledger", path: "/stockledger" },
              { id: 121, label: "Stock Return", path: "/stock-return/list" },
            ]

          },
          {
            id: 182,
            label: "Cheque Managment",
            icon: WSIcons.ShakeHands,
            children: [
              { id: 122, label: "Bank Details", path: "/bank/list" },
              { id: 124, label: "Cheque Entry", path: "/chequeentry/list" },


            ]
          },
          {
            id: 188,
            label: "Sales",
            icon: WSIcons.salesIcon,
            children: [
              { id: 129, label: "Expense", path: "/expense/list" },
              { id: 130, label: "Quotation", path: "/quotation/list" },
              { id: 131, label: "Invoice", path: "/invoice/list" },
            ]
          },
          {
            id: 190,
            label: "Purchase",
            icon: WSIcons.ShoppingCartOutlinedIcon,
            children: [
              { id: 134, label: "Purchase Order", path: "/purchase-order/list" },
              { id: 135, label: "Bills", path: "/purchase/list" },
            ]
          },
          {
            id: 189,
            label: "Administartion",
            icon: WSIcons.UserGroup,
            children: [
              { id: 125, label: "User Management", path: "/user/list" },
              { id: 126, label: "Role Permission", path: "/role-permission" },
              { id: 132, label: "Technician Management", path: "/technician/list" },
            ]
          },

          {
            id: 103,
            label: "Reports",
            icon: WSIcons.reportIcon,
            children: [
              { id: 127, label: "Inventory Report", path: "/inventory/reports" },
              { id: 128, label: "Cheque Report", path: "/cheque/reports" },
            ]
          },
        ]
        : [
          {
            id: 101,
            label: "Dashboard",
            icon: WSIcons.Print,
            path: "/"
          },
          {
            id: 102,
            label: "Inventory",
            icon: WSIcons.OverViewIcon,
            children: [
              { id: 110, label: "Item Master", path: "/itemmaster/list" },
              { id: 111, label: "Category Management", path: "/category/list" },
              { id: 133, label: "Brand", path: "/brand/list" },
              { id: 112, label: "Unit Management", path: "/unit/list" },
              { id: 113, label: "Supplier Management", path: "/supplier/list" },
              { id: 114, label: "Customer Management", path: "/customer/list" },
              { id: 115, label: "Warehouse Management", path: "/warehouse/list" },
              { id: 116, label: "Opening Stock Entry", path: "/openingstock/list" },
              { id: 117, label: "Stock Entry", path: "/stockentry/list" },
              { id: 118, label: "Stock Adjustment", path: "/adjustment/list" },
              { id: 119, label: "Stock Balance", path: "/stock-balance/list" },
              { id: 120, label: "Stock Verification", path: "/verification/list" },
              { id: 121, label: "Stock Ledger", path: "/stockledger" },
            ]

          },
          {
            id: 182,
            label: "Cheque Managment",
            icon: WSIcons.ShakeHands,
            children: [
              { id: 122, label: "Bank Details", path: "/bank/list" },
              { id: 123, label: "Cheque Status", path: "/chequestatus/list" },
              { id: 124, label: "Cheque Entry", path: "/chequeentry" },
            ]
          },
        ]
  };
};